/**
 *
 * @module addressableCreditCard
 *
 */

import Check from 'check-types';
import Address from './address';
import CreditCard from './creditCard';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class AddressableCreditCard
 *
 */
export default class AddressableCreditCard {

    /**
     *
     * @param {SDK.Services.Commerce.Address} address
     * @param {SDk.Services.Commerce.CreditCard} creditCard
     * @throws {InvalidArgumentException}
     *
     */
    constructor(address, creditCard) {

        const errorMessage = {
            ctor: 'AddressableCreditCard(address, creditCard)',
            get address() {
                return `${this.ctor} needs SDK.Services.Commerce.Address instance`;
            },
            get creditCard() {
                return `${this.ctor} needs SDK.Services.Commerce.CreditCard instance`;
            }
        };

        instanceStrict(
            address,
            Address,
            errorMessage.address,
            InvalidArgumentException
        );

        instanceStrict(
            creditCard,
            CreditCard,
            errorMessage.creditCard,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.Address}
         *
         */
        this.address = address;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.CreditCard}
         *
         */
        this.creditCard = creditCard;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/addressableCreditCard.js